import { render, staticRenderFns } from "./dropshipping.vue?vue&type=template&id=3a17db39&scoped=true"
import script from "./dropshipping.vue?vue&type=script&lang=js"
export * from "./dropshipping.vue?vue&type=script&lang=js"
import style0 from "./dropshipping.vue?vue&type=style&index=0&id=3a17db39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a17db39",
  null
  
)

export default component.exports